export default __webpack_public_path__ + "static/media/delivery-icon.7df20ad6.svg";